import { Box, BoxProps, Stack, Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import { ReactNode } from "react";

export interface ErrorProps extends Omit<BoxProps, "component" | "title"> {
    title?: ReactNode,
    message?: ReactNode
}

export default function Error({
    position = "relative",
    title = "Hubo un error inesperado",
    message = "Vuelve a intentarlo mas tarde.",
    children,
    ...props
}: ErrorProps) {
    return <Box position={position} {...props}>
        <Stack
            position={"absolute"} top={0} bottom={0} left={0} right={0}
            alignItems={"center"} justifyContent={"center"} gap={2}
        >
            <ErrorIcon sx={{ fontSize: "3rem" }} color="error" />
            <Stack gap={1} justifyContent={"center"} alignItems={"center"}>
                {title&&<Typography variant="h6" color="error" component={"h2"} textAlign={"center"}>{title}</Typography>}
                {message&&<Typography variant="subtitle2" color="error.light" textAlign={"center"}>{message}</Typography>}
            </Stack>
        </Stack>
    </Box>
}